<template>
	<span class="animated-number">{{ animatedNumber }}</span>
</template>

<script>
import Vue from 'vue';
import gsap from 'gsap';

export default {
	props: {
		number: {
			type: Number,
			required: true,
		},
		precision: {
			type: Number,
			default: 0,
		},
		duration: {
			type: Number,
			default: 0.5,
		},
		filters: {
			type: [Array, String],
			default: '',
			required: false,
		},
		options: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			tweenedNumber: 0,
		};
	},
	computed: {
		animatedNumber() {
			let number = this.tweenedNumber.toFixed(this.precision);

			if (this.filters.length >= 1) {
				const filters = Array.isArray(this.filters) ? this.filters : [this.filters];
				number = filters.reduce((value, filter) => Vue.filter(filter)(value), number);
			}

			return number;
		},
	},
	watch: {
		number(newValue) {
			gsap.to(this.$data, this.duration, {
				tweenedNumber: newValue,
				onStart: () => this.$emit("animation-start"),
				onComplete: () => this.$emit("animation-end"),
			});
		},
	},
	created() {
		this.tweenedNumber = this.number;
	},
};
</script>

<style lang="scss" scoped>
</style>
